// form validation functions for fields in TagGlobalSettingsForm

import type { Tag } from 'flow/store/engine/types';

export const validationMessages = {
  name: {
    maxLength: 'Tag name exceeds the character limit',
    required: 'Name is required.',
    uniqueName: 'A tag with this name already exists. Please enter a unique tag name.',
  },
  description: {
    maxLength: 'You have reached the maximum number of characters',
  },
  caseType: {
    required: 'Case creating tags must have an associated type',
  },
  outcomes: {
    required: 'Adverse action reason tags must have an associated outcome',
  },
};

export function isTagNameUnique(
  tagProps: Tag[],
  tagName: string,
  originalTagName: string | null,
) {
  const trimmedName = tagName.trim();
  if (!trimmedName) return false;

  // If reverting to the original tag name, allow it
  if (originalTagName && trimmedName.toLowerCase() === originalTagName.toLowerCase()) {
    return true;
  }

  // Filter out the tag being edited by matching against the original tag name
  // This works for both ephemeral tags (null IDs) and saved tags (with IDs)
  // Similar to how updateTagInProps finds the matching tag prop
  const filteredTags = tagProps.filter(tag => {
    if (originalTagName && tag.tag_name === originalTagName) {
      return false;
    }
    return true;
  });

  const tagNames = new Set(
    filteredTags
      // normalize (equivalent to BE validation)
      .map(tag => tag.tag_name.toLowerCase()),
  );
  return Boolean(!tagNames.has(trimmedName.toLowerCase()));
}
